import React, { useEffect, useState } from "react";
import axios from "axios";
import { Icon, Modal, Spin, Input, message, Button } from "antd";
import { Translate } from "react-translated";
import F from "../../../Functions";
import moment from "moment";
import DatePicker from "react-datepicker";
import { CALL_BACK_REQUESTED, CALL_BACK_REQUESTED_FOR, REVIEWSCHEDULER, URLPaths, VONBOARDER } from "../../../utils/Constants";
import { withRouter } from "react-router-dom";
import { CREATE_CALL_ATTEMPT_HISTORY, CREATE_CALL_BACK_HISTORY, UPDATE_CALL_BACK_REQUEST_REVIEW } from "../../../utils/Api_enums";
import { useBoundStore } from "../../../store/useBoundStore";

const { TextArea } = Input;
const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;

const CallBackRequestedModal = (props) => {
  const dateFormat = "MM/DD/YYYY";

  // props
  const { title, showModal, hideModal, bfile, user: loggedInUser, history } = props;
  const { rs_effective_date } = bfile;
  const { userInfo } = useBoundStore();
  // states
  const [note, setNote] = useState("");
  const [loading, setLoading] = useState(false);
  const [date, setDate] = useState(moment().format(dateFormat));

  const [defaultSelectedUserRoleInToggle, setDefaultSelectedUserRoleInToggle] = useState(useBoundStore.getState().RSFSCardFilters.defaultToggleUserRole);

  const minDate = moment(rs_effective_date).add(1, 'days').toDate(); // Convert Moment to Date object
  const currentDate = moment().toDate() // Convert Moment to Date object

  // Add days to date
  const addDays = (date, days) => {
    const newDate = new Date(date);
    newDate.setDate(newDate.getDate() + days);
    return newDate;
  };

  // useEffect(() => {
  //   setDefaultSelectedUserRoleInToggle(RSFSCardFilters.defaultToggleUserRole)
  // }, [RSFSCardFilters.defaultToggleUserRole]);


  // handle save
  const handleSave = () => {
    setLoading(true)
    // const notes_type = loggedInUser.user_type === "REVIEWSCHEDULER" ? "Review Scheduler" : "Follow-up Specialist";

    if (note.trim().length === 0) {
      // reset notification
      message.destroy();
      message.error(F.translate(`Note is required.`));
      return;
    }

    let payload = {
      "rs_effective_date": moment(date).format("YYYY-MM-DD"),
      "expiration_date": moment(addDays(date, 30)).format("YYYY-MM-DD"),
    }
    let call_back_requested_for_actions;
    if ((loggedInUser && loggedInUser.user_type === REVIEWSCHEDULER) ||
      defaultSelectedUserRoleInToggle == REVIEWSCHEDULER) {
      let bfile_sub = bfile && bfile.bfile_sub && bfile.bfile_sub[0] ? [{
        id: bfile.bfile_sub[0].id,
        rs_review_month: Number(moment(date).format("M"))
      }] : [];
      payload = {
        "rs_effective_date": moment(date).format("YYYY-MM-DD"),
        expiration_date: moment(date).endOf('month').format("YYYY-MM-DD"),
        // "expiration_date": moment(addDays(date, 30)).format("YYYY-MM-DD"),
        rs_consecutive: 0,
        archive: 0,
        rs_attempts: bfile.rs_attempts ? bfile.rs_attempts + 1 : 1,
        non_responsive: 0, // to remove from non-responsive grid 
        rs_action: null, // to remove for review of  - not reached and not interested  grids 
        reschedule_appointment: 0, // to remove from RS reschedule grid
        rs_date: moment(new Date())
          .utc()
          .format("YYYY-MM-DD HH:mm:ss"),
        bfile_sub
      }
      call_back_requested_for_actions = `${CALL_BACK_REQUESTED_FOR} ${moment(date).format("MM-DD-YYYY")}`
    } else {
      let bfile_sub = bfile && bfile.bfile_sub && bfile.bfile_sub[0] ? [{
        fs_effective_date: moment(date).format("YYYY-MM-DD"),
        // fs_expiration_date: moment(addDays(date, 30)).format("YYYY-MM-DD"),
        fs_expiration_date: moment(date).endOf('month').format("YYYY-MM-DD"),
        id: bfile.bfile_sub[0].id,
        followup_month: Number(moment(date).format("M"))
      }] : [];
      payload = {
        // "rs_effective_date": moment(date).format("YYYY-MM-DD"),
        // "expiration_date": moment(addDays(date, 30)).format("YYYY-MM-DD"),
        fs_consecutive: 0,
        archive: 0,
        vo_claim_date: null,
        vob_archived: null,  //  to removecall_attempts_history from fs not interested  grid
        vob_completed: null,
        vob_attempted: null, // to remove from fs not reached grid 
        non_responsive: 0, // to remove from non-responsive grid 
        von_appointment_date: null,
        reschedule_appointment_vo: 0, // to remove from FS reschedule grid,
        bfile_sub,
        onboarding_id: userInfo.id,
        onboarder_id: userInfo.id
      }
      call_back_requested_for_actions = `${CALL_BACK_REQUESTED_FOR} ${moment(date).format("MM-DD-YYYY")}`
    }

    // Call Notes API
    axios.post("/api/bfile_notes", {
      bfile_id: bfile.id,
      note: note,
      user_id: loggedInUser.id,
      action: call_back_requested_for_actions,
      type_of_call: bfile.type_of_call,
      sub_type_of_call: bfile.sub_type_of_call,
      notes_type: F.getNotesType()
    });


    if ((loggedInUser && loggedInUser.user_type === REVIEWSCHEDULER) ||
      defaultSelectedUserRoleInToggle == REVIEWSCHEDULER) {
      const bfile_id = bfile.id;
      const review_month = moment(date).format("M");
      const url = UPDATE_CALL_BACK_REQUEST_REVIEW(bfile_id, review_month);
      axios.put(url).then((res) => {
        console.log("PUT success:", res.data);
      })
        .catch((error) => {
          console.error("PUT failed:", error);
        })
    }


    // Call Back Requested API for call attempts
    if ((loggedInUser && loggedInUser.user_type !== REVIEWSCHEDULER) &&
      defaultSelectedUserRoleInToggle != REVIEWSCHEDULER) {
      axios.post("/api/ea_questions", {
        bfile_id: bfile.id,
        call_attempts: 1,
        was_invite_sent: false
      });
    }

    axios.put("/api/b_file/" + bfile.id, {
      ...payload,
    }).then(() => {
      // setLoading(false);
      hideModal();
      // history.push("/dashboard");
      // history.replace(URLPaths.BFILES);
      props.history.goBack();


      // setTimeout(() => {
      //   props.init()
      // }, 100);

    });

    saveCallAttemptHistory(bfile, "call_back_requested");
  }

  const saveCallAttemptHistory = (bfile, action) => {

    try {

      axios.post(CREATE_CALL_ATTEMPT_HISTORY,
        {
          bfile_id: bfile.id,
          scheduler_specialist_id: loggedInUser.id,
          bfile_user_id: bfile.user_id,
          agency_id: bfile.agency_id,
          type_of_call: bfile.type_of_call,
          sub_type_of_call: bfile.sub_type_of_call,
          first_name: bfile.first_name,
          last_name: bfile.last_name,
          phone: bfile.phone,
          action: action
        });


      axios.post(CREATE_CALL_BACK_HISTORY,
        {
          bfile_id: bfile.id,
          scheduler_specialist_id: loggedInUser.id,
          bfile_user_id: bfile.user_id,
          agency_id: bfile.agency_id,
          rs_effective_date: moment(date).format("YYYY-MM-DD"),
          expiration_date: moment(addDays(date, 30)).format("YYYY-MM-DD"),
          previous_rs_effective_date: bfile.rs_effective_date,
          previous_expiration_date: bfile.expiration_date,
          type_of_call: bfile.type_of_call,
          sub_type_of_call: bfile.sub_type_of_call,
          first_name: bfile.first_name,
          last_name: bfile.last_name,
          phone: bfile.phone
        });
    } catch (error) {
      console.log(error);
    }
  }





  return (
    <Modal
      title={<Translate text={title} />}
      visible={showModal}
      // onOk={() => {
      //   handleSave()
      // }}
      onCancel={hideModal}
      // okText={<Translate text={`Save`} />}
      footer={
        <React.Fragment>
          <Button onClick={hideModal}
            className="borderRadius-28"
          >
            <Translate text={`Cancel`} />
          </Button>
          <Button
            loading={loading}
            className="btn-bg-164897 borderRadius-28" onClick={handleSave}>
            <Translate text={`Save`} />
          </Button>
        </React.Fragment>
      }
      width={"600px"}
    >
      <Spin indicator={antIcon} spinning={loading}>
        <div>
          {/* Date calendar come here  */}
          <Translate text={"Active Call Date"} />
          <br />
          <DatePicker
            dateFormat={dateFormat}
            showYearDropdown
            showMonthDropdown
            dropdownMode="select"
            style={{ width: "100%" }}
            value={date}
            // minDate={minDate}
            minDate={currentDate}
            // showTimeSelect
            onChange={(val) => {
              const date = moment(val).format(dateFormat);
              setDate(date);
            }}
          />
          <div style={{ marginTop: 15 }}>
            <label>
              <Translate text={`Note`} />
              <span className="asteriskIcon">*</span>
            </label>
            <TextArea
              rows={4}
              value={note}
              onChange={(e) => setNote(e.target.value)}
            />
          </div>
        </div>
      </Spin>
    </Modal>
  );
};

export default withRouter(CallBackRequestedModal);



// WEBPACK FOOTER //
// ./src/scenes/LandingPage/components/CallBackRequestedModal.js